export default "__VITE_ASSET__64eabad7__"